import React from 'react'

export type Testimonial = {
  quote: string
  name: string
  title: string
  company: string
}

export type CaseStudy = {
  title: string
  summary: string
  href: string
}

export type TrustedByLogo = {
  name: string
  logoSrc: string
  href?: string
}

// Fill these in as real users/customers sign off. Leave empty and the
// section stays hidden — never populate with placeholder/fake entries.
export const testimonials: Testimonial[] = []
export const caseStudies: CaseStudy[] = []
export const trustedByLogos: TrustedByLogo[] = []

const SocialProof: React.FC = () => {
  const hasContent = testimonials.length > 0 || caseStudies.length > 0 || trustedByLogos.length > 0
  if (!hasContent) return null

  return (
    <section className="border-y border-white/5 bg-void px-6 py-24 lg:px-12">
      <div className="mx-auto max-w-6xl">
        <div className="mb-12 max-w-3xl">
          <div className="mb-3 text-xs font-mono-tech uppercase tracking-[0.24em] text-zypheron-400">Trusted by</div>
          <h2 className="text-3xl font-bold tracking-tight text-white font-display md:text-4xl">What operators are saying</h2>
        </div>

        {trustedByLogos.length > 0 && (
          <div className="mb-14 flex flex-wrap items-center gap-x-12 gap-y-6 opacity-80">
            {trustedByLogos.map((logo) => (
              <a
                key={logo.name}
                href={logo.href || '#'}
                target={logo.href ? '_blank' : undefined}
                rel={logo.href ? 'noopener noreferrer' : undefined}
                className="grayscale transition hover:grayscale-0"
              >
                <img src={logo.logoSrc} alt={logo.name} className="h-8 w-auto" />
              </a>
            ))}
          </div>
        )}

        {testimonials.length > 0 && (
          <div className="grid gap-6 md:grid-cols-3">
            {testimonials.map((t) => (
              <div key={t.name} className="border border-white/10 bg-panel/80 p-8">
                <p className="mb-6 text-sm leading-6 text-gray-300">&ldquo;{t.quote}&rdquo;</p>
                <div className="text-sm font-semibold text-white">{t.name}</div>
                <div className="text-xs text-gray-500">{t.title}, {t.company}</div>
              </div>
            ))}
          </div>
        )}

        {caseStudies.length > 0 && (
          <div className="mt-14 grid gap-6 md:grid-cols-2">
            {caseStudies.map((cs) => (
              <a key={cs.title} href={cs.href} className="block border border-white/10 bg-panel/80 p-8 transition-colors hover:border-zypheron-500/40">
                <h3 className="mb-3 text-lg font-semibold text-white">{cs.title}</h3>
                <p className="text-sm leading-6 text-gray-400">{cs.summary}</p>
              </a>
            ))}
          </div>
        )}
      </div>
    </section>
  )
}

export default SocialProof
